import APIRequestState from '../_util/api-request';

/** body: {email, password} */
class LoginState extends APIRequestState {
  get method() { return 'POST'; }
  get url() { return '/auth/login'; }
}

export default LoginState;



// WEBPACK FOOTER //
// ./spa/state/session/login.jsx